








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'header.vue'
})
export default class extends Vue {
  @Prop({ required: true }) private title!: string
  @Prop({ required: true }) private leftText!: string
  @Prop({ default: () => {} }) private backup!: Function

  onBackup(){
    this.$emit('backup')
  }
}
